// Options pour le type de formalité
export const TYPES_FORMALITE = [
  "Augmentation de capital",
  "Autres",
  "BODACC",
  "Changement date de clôture",
  "Changement de dénomination sociale / nom commercial / enseigne",
  "Correction RNE",
  "Déclaration des bénéficiaires effectifs",
  "Dépôt d'actes",
  "Dissolution et clôture de liquidation",
  "Fusion",
  "Immatriculation",
  "Mise à jour des associés",
  "Mise en sommeil",
  "Modification de l'objet social / activités",
  "Modification des organes de direction / associés",
  "Ouverture / fermeture / transfert d'un établissement",
  "Prise d'activité",
  "Prolongation de la durée",
  "Transfert de siège",
  "Transformation",
  "TUP",
  "Réduction de capital",
  "Radiation El",
  "Continuation malgré les pertes",
  "Reconstitution des capitaux propres",
  "Dépôt des comptes",
] as const;

// Options pour l'étape/statut
export const ETAPES = [
  "Reçu",
  "En cours",
  "Incomplet",
  "Transmis",
  "Validé",
  "A facturer",
  "Clos",
] as const;

// Options pour l'enregistrement
export const ENREGISTREMENTS = [
  "Envoyé",
  "Reçu",
] as const;

// Options d'états
export const ETATS = [
  "Envoyé",
  "Reçu",
] as const;

export type TypeFormalite = typeof TYPES_FORMALITE[number];
export type Etape = typeof ETAPES[number];
export type Enregistrement = typeof ENREGISTREMENTS[number];
export type Etat = typeof ETATS[number];
